import { useEffect, useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Box, ListSubheader, Typography } from '@mui/material';

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => <ListSubheader disableSticky disableGutters {...props} />)(
  ({ theme }) => ({
    ...theme.typography.overline,
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
    }),
  })
);

// ----------------------------------------------------------------------

export default function NavVersion({ ...other }) {
  const [version, setVersion] = useState('');

  useEffect(() => {
    setVersion(import.meta.env.VITE_APP_VERSION);
  }, []);

  return (
    <Box {...other}>
      <Typography
        variant={'caption'}
        sx={{
          color: 'text.secondary',
          margin: 2,
        }}
      >
        {version}
      </Typography>
    </Box>
  );
}

NavVersion.propTypes = {};
